import "vite/modulepreload-polyfill";

import { VueQueryPlugin } from "@tanstack/vue-query";
import { createApp } from "vue";

import App from "./components/App.vue";

const newsletterElement = document.getElementById("newsletter");
const subscriberFacingAuthElement = document.getElementById(
  "subscriber_facing_authentication"
);
const subscriberFacingFlashElement = document.getElementById(
  "subscriber_facing_flash"
);

if (newsletterElement) {
  const NEWSLETTER = JSON.parse(newsletterElement.textContent);
  const SUBSCRIBER_FACING_AUTHENTICATION = subscriberFacingAuthElement
    ? JSON.parse(subscriberFacingAuthElement.textContent)
    : null;
  const SUBSCRIBER_FACING_FLASH = subscriberFacingFlashElement
    ? JSON.parse(subscriberFacingFlashElement.textContent)
    : null;

  // Determine variant - use global VARIANT if set, otherwise check for email element
  const VARIANT =
    typeof window !== "undefined" && window.VARIANT
      ? window.VARIANT
      : document.getElementById("email")
      ? "archive_page"
      : "subscribe_page";

  const surveysElement = document.getElementById("surveys");
  const SURVEYS = surveysElement ? JSON.parse(surveysElement.textContent) : [];
  const formIdElement = document.getElementById("form-id");
  const FORM_ID = formIdElement ? JSON.parse(formIdElement.textContent) : null;

  const app = createApp(App, {
    newsletter: NEWSLETTER,
    subscriberFacingAuthentication: SUBSCRIBER_FACING_AUTHENTICATION || {
      status: "unauthenticated",
      email_address: null,
      subscribers: [],
    },
    subscriberFacingFlash: SUBSCRIBER_FACING_FLASH,
    variant: VARIANT,
    surveys: SURVEYS,
    formId: FORM_ID,
  });

  app.use(VueQueryPlugin);

  // Mount to body since App.vue is a provider component that doesn't render visible content
  app.mount(document.getElementById("subscriber-facing-app"));
}
